"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCookie = exports.setCookie = exports.getCookie = exports.parseCookies = void 0;
function parseCookies() {
    var pairs = document.cookie.split(";");
    var cookies = {};
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        cookies[(pair[0] + '').trim()] = decodeURIComponent(pair.slice(1).join('='));
    }
    return cookies;
}
exports.parseCookies = parseCookies;
function getCookie(key) {
    var cookies = parseCookies();
    var keys = Object.keys(cookies);
    return keys.includes(key) ? cookies[key] : null;
}
exports.getCookie = getCookie;
function setCookie(key, value) {
    document.cookie = "".concat(key, "=").concat(value, "; path=/; SameSite=Lax");
}
exports.setCookie = setCookie;
function removeCookie(key) {
    document.cookie = "".concat(key, "=; Max-Age=0; path=/");
}
exports.removeCookie = removeCookie;
